module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar-large",
    staticStyle: {
      "margin-top": "5em",
      "margin-left": "-2em",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "bottombar"
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/manage/items"
    }
  }, [_c('i', {
    staticClass: "fas fa-list",
    attrs: {
      "id": "m_orders"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Stock")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/manage/lists"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-cart",
    attrs: {
      "id": "m_orders"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Lists")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/manage/customers"
    }
  }, [_c('i', {
    staticClass: "fas fa-users",
    attrs: {
      "id": "m_account"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Customers")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Feeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/shop"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fas fa-store-alt",
    attrs: {
      "id": "m_trending"
    }
  }), _c('br'), _c('span', [_vm._v("Shop")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7526bc4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/manage_menubottom.vue
// module id = 600
// module chunks = 0